import React from 'react';
import TabMenu from './TabMenu';

const Navigation = () => {
  return (
    <div className="navigation-container">
      <TabMenu />
    </div>
  );
};

export default Navigation; 